import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DeadlineCalendar({ active, show }) {
  const [data, setData] = useState(null);
  const load = useCallback(() => {
    axios.get(`${API}/masterfile/current`).then((r) => setData(r.data)).catch(() => {});
  }, []);
  useEffect(() => { if (active === "cal") load(); }, [active, load]);

  const empty = !data || data.empty;
  const cases = (data?.cases || []).filter((c) => !c.payment_received_date);
  const atRisk = cases.filter((c) => c.next_window && c.window_days_left != null);
  const missed = cases.filter((c) => c.missed_windows.length);

  return (
    <section className={`chapter utility${active === "cal" ? " active" : ""}`} id="cal">
      <div className="eyebrow">Read-only computed view · statutory business-day windows (45 CFR 149.510) from master-file dates</div>
      <h1>Statutory Windows — At Risk &amp; Missed</h1>
      {!empty && <div className="vr-pill open" data-testid="cal-asof" style={{ marginBottom: 10 }}>DATA AS OF {data.as_of} — a window can open and close between file drops. The live watch is SOP 13.4: Jeff/Luz verify pending Stage 9–10 windows weekly inside Alteva's systems; this view is the computed backup.</div>}
      <p className="lede">The business-day math is ported verbatim from the retired per-claim calendar: open negotiation must start within 30 business days of the remittance; IDR initiates in the 4-business-day window after the 30-business-day negotiation period (business days 31–34 — the hard stop). The operational "~30 days" in the lifecycle table is the vendor working inside these statutory limits — which is which is a [VERIFY] item for counsel (V-17).</p>

      {empty ? (
        <div className="formcard" data-testid="cal-empty">No data — upload monthly master file. <button className="vr-link" onClick={() => show("mcf")}>Go to Monthly Case File →</button></div>
      ) : (
        <>
          <h2>Windows at risk — {atRisk.length}</h2>
          <table data-testid="cal-atrisk-table"><tbody>
            <tr><th>Case ID</th><th>Payer</th><th>Next window</th><th>Deadline</th><th>Days left</th></tr>
            {atRisk.length === 0 ? <tr><td colSpan={5}>No open windows at risk in the current file.</td></tr> :
              atRisk.map((c) => (
                <tr key={c.case_id}><td className="q">{c.case_id}</td><td>{c.payer || "—"}</td><td>{c.next_window}</td>
                  <td>{c.next_window.includes("IDR") ? c.idr_initiation_deadline : c.neg_open_deadline}</td>
                  <td><span className={`vr-pill ${c.window_days_left <= 5 ? "declined" : "open"}`}>{c.window_days_left}d</span></td></tr>
              ))}
          </tbody></table>

          <h2>Missed windows — {missed.length} case(s), standard: zero</h2>
          <table data-testid="cal-missed-table"><tbody>
            <tr><th>Case ID</th><th>Payer</th><th>Missed</th><th>Stage</th></tr>
            {missed.length === 0 ? <tr><td colSpan={4}>None — clean file.</td></tr> :
              missed.map((c) => (
                <tr key={c.case_id}><td className="q">{c.case_id}</td><td>{c.payer || "—"}</td>
                  <td>{c.missed_windows.map((w, i) => <div key={i}><span className="vr-pill declined">{w}</span></div>)}</td>
                  <td>{c.current_stage || "—"}</td></tr>
              ))}
          </tbody></table>
        </>
      )}
      <p style={{ color: "var(--mute)", fontSize: "13px" }}>Per-claim entry retired in the v1.8-D conversion; pre-conversion claims preserved in the legacy archive. The missed-window rate feeds the lender report and MOCR A-4 unchanged in definition (method-change footnote on the first converted report).</p>
    </section>
  );
}
